import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { useNavigate } from "react-router-dom";
import React from "react";
import {
  Backdrop,
  CircularProgress,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Tooltip,
} from "@mui/material";
import { useOutletContext } from "react-router-dom";
import GetSurveyBasicList from "hooks/SurveyBasicList/GetSurveyBasicList";
import SearchInput from "components/searchInput";
import DataTable from "comps/Tables/DataTable";
import MDTypography from "components/MDTypography";
import GetListOfClients from "hooks/ListOfClients/GetListOfClients";
import GetSurveyStatusList from "hooks/SurveyStatusList/GetSurveyStatusList";
import moment from "moment";
import csvDownload from "json-to-csv-export";
import Union2 from "assets/images/Union2.png";
import colors from "assets/theme/base/colors";
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';
function SurveyList() {
  const navigate = useNavigate();
  const {
    surveys,
    isLoading,
    totalLength,
    setPage,
    page,
    setSearch,
    search,
    setFilter,
    setClientFilter,
    clientFilter,
    filter,
    entriesPerPage,
    setEntriesPerPage,
    setSortOrder,
    setSortBy,
    sortBy,
    sortOrder,
    setIsLoading,
  } = GetSurveyBasicList(2, -1);
  const { setSurvey, setIsEdit } = useOutletContext();
  const { clients } = GetListOfClients();
  const { surveyStatusList } = GetSurveyStatusList();

  let rows = surveys;
  let { primary } = colors;

  let columns = [
    {
      accessor: "id",
      Header: "Id",
      align: "left",
      sortable: true,
      Cell: ({ row }) => {
        return (
          <div
            style={{ cursor: "pointer" }}
            onClick={() => {
              setIsEdit({
                disabled: true,
                edit: false,
              });
              navigate(`/surveys/${row.original.id}`);
            }}
          >
            {row?.original?.id}
          </div>
        );
      },
    },

    // {
    //   accessor: "surveyName",
    //   Header: "Name",
    //   sortable: false,
    //   align: "center",
    //   headerAlign: "center",
    //   Cell: ({ row }) => {
    //     const name = row?.original?.surveyName;
    //     const truncatedName = name.length > 25? name.substring(0, 25) + "..." : name;
    //     return (
    //       <Tooltip title={name}>
    //         <div
    //           onClick={() => {
    //             setIsEdit({
    //               disabled: true,
    //               edit: false,
    //             });
    //             navigate(`/surveys/${row.values.id}`);
    //           }}
    //         >
    //           {truncatedName}
    //           <br />

    //         </div>
    //       </Tooltip>
    //     );
    //   },
    // },
    {
      accessor: "surveyName",
      Header: "Survey Name",
      sortable: false,
      align: "left",
      headerAlign: "left",
      Cell: ({ row }) => {
        const name = row?.original?.surveyName;
        // const truncatedName = name.length > 10 ? name.substring(0, 10) + "..." : name;
        return (
          <Tooltip title={name}>
            <div
              style={{
                paddingLeft: "8px",
                paddingRight: "8px",
                maxWidth: "150px",
                whiteSpace: "nowrap", // important for ellipsis
                overflow: "hidden", // important for ellipsis
                textOverflow: "ellipsis", // important for ellipsis
                cursor: "pointer",
              }}
              onClick={() => {
                setIsEdit({
                  disabled: true,
                  edit: false,
                });
                navigate(`/surveys/${row.values.id}`);
              }}
            >
              {name}
            </div>
          </Tooltip>
        );
      },
    },

    {
      accessor: "buyerName",
      Header: "Buyer Name",
      description: "This column has a value getter and is not sortable.",
      sortable: false,
      align: "left",
      Cell: ({ row }) => {
        const name = row?.original?.buyerName || "";
        const truncatedName =
          name.length > 10 ? name.substring(0, 10) + "..." : name;
        return (
          <Tooltip title={name}>
            <div>{truncatedName}</div>
          </Tooltip>
        );
      },
    },

    {
      accessor: "sampleRequired",
      Header: "Samp. Req.",
      align: "center",
      sortable: true,
      headerAlign: "center",
    },
    {
      accessor: "revenue",
      Header: "Rev.",
      align: "center",
      sortable: true,
      headerAlign: "center",
      Cell: ({ row }) => {
        const revenue = parseFloat(row?.original?.revenue);
        const roundedRevenue = Math.round(revenue * 100) / 100;
        return roundedRevenue.toFixed(2);
      },
    },
    {
      accessor: "loi",
      Header: "Loi",
      align: "center",
      sortable: true,
      headerAlign: "center",
    },

    {
      accessor: "ir",
      Header: "IR",
      align: "center",
      sortable: true,
      headerAlign: "center",
    },
    {
      accessor: "cpi",
      Header: "CPI",
      align: "center",
      sortable: true,
      headerAlign: "center",
      Cell: ({ row }) => {
        const cpi = parseFloat(row?.original?.cpi);
        const roundedCpi = Math.round(cpi * 100) / 100;
        return roundedCpi.toFixed(2);
      },
    },

    {
      accessor: "starts",
      Header: "S",
      align: "center",
      sortable: true,
      headerAlign: "center",
    },

    {
      accessor: "completes",
      Header: "Comp.",
      align: "center",
      sortable: true,
      headerAlign: "center",
    },
    {
      accessor: "epc",
      Header: "EPC",
      align: "center",
      sortable: false,
      headerAlign: "center",
      Cell: ({ row }) => {
        return parseFloat(
          row?.original?.starts <= 0
            ? 0
            : row.original.revenue / row?.original?.starts
        ).toFixed(2);
      },
    },
    {
      accessor: "conversion",
      Header: "Conv(%)",
      align: "left",
      sortable: false,
      headerAlign: "left",
      Cell: ({ row }) => {
        return (
          <div>
            {parseFloat(
              row?.original?.starts <= 0
                ? 0
                : row.original.completes / row?.original?.starts
            ).toFixed(2)}
          </div>
        );
      },
    },
    {
      accessor: "clientOverallEpc",
      Header: "Cli. Epc",
      align: "center",
      sortable: false,
      headerAlign: "center",
      Cell: ({ row }) => {
        const epc = row?.original?.clientOverallEpc;
        return epc !== null && epc !== undefined
          ? parseFloat(epc).toFixed(2)
          : "NA";
      },
    },
    {
      accessor: "clientOverallConversion",
      Header: "Cli. conv.",
      align: "center",
      sortable: false,
      headerAlign: "center",
      Cell: ({ row }) => {
        const conversion = row?.original?.clientOverallConversion;
        return conversion !== null && conversion !== undefined
          ? parseFloat(conversion).toFixed(2)
          : "NA";
      },
    },
    {
      accessor: "countryCode",
      Header: "Country",
      align: "center",
      sortable: false,
      headerAlign: "center",
    },
    {
      accessor: "createdAt",
      Header: "Created at",
      align: "left",
      sortable: true,
      headerAlign: "left",
      Cell: ({ row }) => {
        const createdAtTime = moment(row?.values?.createdAt);

        const formattedDateTime = createdAtTime.format(
          "Do MMM YYYY, h:mm:ss a"
        );
        const truncatedName =
          formattedDateTime.length > 15
            ? formattedDateTime.substring(0, 15) + "..."
            : formattedDateTime;
        return (
          <Tooltip title={formattedDateTime}>
            <div style={{
              paddingLeft: "8px",
              paddingRight: "8px",
              maxWidth: "120px",
              whiteSpace: "nowrap", // important for ellipsis
              overflow: "hidden", // important for ellipsis
              textOverflow: "ellipsis", // important for ellipsis
              cursor: "pointer",
            }}>{truncatedName}</div>
          </Tooltip>
        );
      },
    },

    {
      accessor: "lastCompleted",
      Header: "Last Complete",
      align: "left",
      sortable: true,
      headerAlign: "left",
      Cell: ({ row }) => {
        const lastCompletedTime = moment(row?.values?.lastCompleted);
        if (
          !lastCompletedTime.isValid() ||
          row?.values?.lastCompleted === null
        ) {
          return <div>NA</div>;
        }
        const formattedDateTime = lastCompletedTime.format(
          "Do MMM YYYY, h:mm:ss a"
        );
        const truncatedName =
          formattedDateTime.length > 15
            ? formattedDateTime.substring(0, 15) + "..."
            : formattedDateTime;
        return (
          <Tooltip title={formattedDateTime}>
            <div style={{
              paddingLeft: "8px",
              paddingRight: "8px",
              maxWidth: "120px",
              whiteSpace: "nowrap", // important for ellipsis
              overflow: "hidden", // important for ellipsis
              textOverflow: "ellipsis", // important for ellipsis
              cursor: "pointer",
            }}>{truncatedName}</div>
          </Tooltip>
        );
      },
    },
    {
      accessor: "surveyStatusName",
      Header: "Status",
      align: "center",
      sortable: false,
      headerAlign: "center",
    },
  ];
  return (
    <MDBox width="100%">
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {/* <MDTypography color="textColor" ml="1%">
        Surveys
      </MDTypography> */}
      <Grid container spacing={1} pb={1} mb={1}
        sx={{
          // flexDirection: { xs: "column", md: "row" },
          // alignItems: { xs: "flex-end", md: "center" },
          borderBottom: `2px solid ${primary.main}`,
        }}
      >
        <Grid
          px={0}
          item
          xs={2}
          md={2}
          display="flex"
          alignItems={"center"}
          flexDirection="row"
          sx={{
            // flexDirection: { xs: "column", md: "row" },
            // alignItems: { xs: "flex-end", md: "center" },
          }}
          gap="15px"
        >
          <MDTypography fontSize="22px" color="black" >
            Surveys
          </MDTypography>
        </Grid>
        <Grid
          px={1}
          item
          xs={10}
          md={10}
          display="flex"
          justifyContent="flex-end"
          flexDirection="row"
          sx={{
            flexDirection: { xs: "column", md: "row" },
            alignItems: { xs: "flex-end", md: "center" },
          }}
          gap="15px"
        >
          <MDButton
            variant="contained"
            color="info"
            onClick={() => {
              navigate("/surveys/new");
              setSurvey({});
              setIsEdit({
                disabled: false,
                edit: false,
              });
            }}
          >
            + New Survey
          </MDButton>
        </Grid>
      </Grid>
      <MDBox display="flex" justifyContent="center">
        <MDBox py={1} pb={2} mt={1} pl={1} mr={1} borderRadius="5px" bgColor="white" width="100%">
          <Grid container spacing={2} pb={1} px={1}>
            <Grid
              px={1}
              item
              xs={12}
              md={12}
              display="flex"
              justifyContent="flex-end"
              flexDirection="row"
              sx={{
                flexDirection: { xs: "column", md: "row" },
                alignItems: { xs: "flex-end", md: "center" },
              }}
              gap="8px"
            >
              <Grid item xs={12} md={2} pr={1}>
                <FormControl fullWidth>
                  <InputLabel>Clients</InputLabel>
                  <Select
                    value={clientFilter}
                    label="Clients"
                    onChange={(e) => {
                      setClientFilter(e.target.value);
                    }}
                  >
                    <MenuItem value={-1}>All</MenuItem>
                    {clients?.map((value, i) => (
                      <MenuItem value={value.id} key={i}>
                        {value.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={2} pr={1}>
                <FormControl fullWidth>
                  <InputLabel>Status</InputLabel>
                  <Select
                    value={filter}
                    label="Status"
                    onChange={(e) => {
                      setFilter(e.target.value);
                    }}
                  >
                    <MenuItem value={-1}>All</MenuItem>
                    {surveyStatusList?.map((value, i) => {
                      return (
                        <MenuItem key={i} value={value.id}>
                          {value.name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </Grid>

              <SearchInput setSearch={setSearch} search={search} />
              <Tooltip title="Download Surveys" placement="top">
                <IconButton
                  size="large"
                  sx={{ padding: "0px", marginLeft: "5px" }}
                  variant="gradient"
                  // color="info"
                  onClick={() => {
                    const dataToConvert = {
                      data: surveys,
                      filename: `SurveyPage${page}`,
                      delimiter: ",",
                    };
                    csvDownload(dataToConvert);
                  }}
                >
                  <DownloadForOfflineIcon />
                </IconButton>
              </Tooltip>
              {/* <MDButton
                variant="contained"
                color="info"
                onClick={() => {
                  navigate("/surveys/new");
                  setSurvey({});
                  setIsEdit({
                    disabled: false,
                    edit: false,
                  });
                }}
              >
                + New Survey
              </MDButton> */}
            </Grid>
          </Grid>

          <DataTable
            table={{ columns, rows }}
            isSorted
            noEndBorder
            entriesPerPage={entriesPerPage}
            canSearch={false}
            tablePage={page}
            setTablePage={setPage}
            navigateRow={"/surveys"}
            setEntriesPerPage={setEntriesPerPage}
            totalLength={totalLength}
            pagination={true}
            setSortOrder={setSortOrder}
            setSortBy={setSortBy}
            rowWidth={"40px"}
            sortBy={sortBy}
            sortOrder={sortOrder}
            setIsLoading={setIsLoading}
            tableMaxHeight={"calc(100vh - 290px)"}
            tableMinHeight={"calc(100vh - 290px)"}
          />
        </MDBox>
      </MDBox>
    </MDBox>
  );
}

export default SurveyList;
